import { NewCurrency } from '../types/api/Currency/Currency';
import * as CurrencyHelpers from './currency';

/** Returns (1 - cost/price) * 100, rounded to 3 decimals, or null if price is NaN or <= 0. */
export const CalculateMarginPercentage = (priceUnit: number, costUnit: number): number | null => {
  if (Number.isNaN(priceUnit) || priceUnit <= 0) {
    return null;
  }
  const marginNumber = (1 - costUnit / priceUnit) * 100;
  // TODO: Replace this with decimal precision in sc-1251
  return parseFloat(marginNumber.toFixed(3));
};

/** Returns price - cost, or null if price is NaN or <= 0. */
export const CalculateMarginCurrencyNumber = (
  priceUnit: number,
  costUnit: number,
): number | null => {
  if (Number.isNaN(priceUnit) || priceUnit <= 0) {
    return null;
  }
  return priceUnit - costUnit;
};

/** Formats a margin percentage (from CalculateMarginPercentage) as e.g. "12.5%". */
export const FormatMarginPercentage = (marginPercentage: number | null): string | null =>
  marginPercentage === null ? null : `${marginPercentage.toLocaleString('en-US')}%`;

/** Formats a margin currency number (from CalculateMarginCurrencyNumber) via CurrencyString. */
export const FormatMarginCurrency = (
  marginNumber: number | null,
  currencyCode?: string | null,
): string | null =>
  marginNumber === null
    ? null
    : CurrencyHelpers.CurrencyString({
        cur: NewCurrency({ number: String(marginNumber) }),
        currencyCode,
      });
